import { createPortal } from "react-dom";

/**
 * Renders children into document.body to escape any ancestor with `transform`,
 * `filter`, or `backdrop-filter` (which all create containing blocks for
 * `position: fixed` descendants). Use for any modal/overlay.
 */
export default function Portal({ children }) {
  if (typeof document === "undefined") return null;
  return createPortal(children, document.body);
}
